import React from 'react';
import { Link, useLocation } from 'wouter';
import { AppBar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import type { MenuOptions } from '../types/general';
import Menu from './Menu';

type Props = MenuOptions & {};

function Header(props: Props) {
  const theme = useTheme();
  const [location] = useLocation();

  const headerTheme = theme.palette.header;
  const menuTheme = theme.palette.menu;
  const subMenuTheme = theme.palette.subMenu;

  const currentEntry = props.entries.find(({ link }) => {
    const firstRoutePart = link.substring(0, link.lastIndexOf('/') + 1);
    return location.startsWith(firstRoutePart);
  });

  return (
    <AppBar position='sticky' color='transparent' sx={{ background: headerTheme.background }}>
      <Container
        maxWidth={false}
        disableGutters
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: '65px',
          padding: '7px 24px',
          marginBottom: '5px',
        }}
      >
        <Link href={props.logoLink} className='logo-link'>
          <img src={props.logo} alt='Logo' />
          <Typography variant='h6' noWrap sx={{ fontWeight: 'bold', color: headerTheme.color }}>
            {props.title}
          </Typography>
        </Link>
      </Container>
      <Menu theme={menuTheme} entries={props.entries} showLogoutButton={props.hasLogout} />
      {currentEntry !== undefined && currentEntry.subEntries !== undefined && (
        <Menu theme={subMenuTheme || menuTheme} entries={currentEntry.subEntries} showLogoutButton={false} />
      )}
    </AppBar>
  );
}

export default Header;
